<template>
  <li class="products__item" :class="{ 'products__item--hover': hover, 'products__item--popup': additionalLinksMenuFocused }">
    <div class="products__item-inner">
      <a class="products__link"
        :class="{ 'scrollmagic__fade-in-up': scrollmagic && !$firefox }"
        :id="id"
        :href="href"
        @click="click"
      >
        <div class="products-image">
          <div class="products__image"
            v-if="image"
            :style="{ backgroundImage: `url(${ image.url })` }"
          ></div>
          <div class="products__image" v-else></div>
          <div class="products-overlay"></div>

          <div class="products-stats products-stats--top">
            <div v-if="hot" class="products-stats__badge">
              <i class="products-stats__icon products-stats__icon--hot-product">Hot Product</i>
            </div>
            <div v-if="published === null" class="products-stats__badge">
              <ProductTileBadge text="Unavailable" />
            </div>
          </div>
          <div class="products-stats products-stats--bottom">
            <div class="products-stat">
              <div class="products-stat__result">{{ inventory }}</div>
              <div class="products-stat__type">Current Stock</div>
            </div>
            <div class="products-stat">
              <div class="products-stat__result">{{ unitsSold }}</div>
              <div class="products-stat__type">Units Sold</div>
            </div>
            <div class="products-stat">
              <div class="products-stat__result products-stat__result--bold">
                <i-count-up
                  :start="0"
                  :end="totalSales"
                  :decimals="2"
                  :duration="1"
                  :options="countUpMoney"
                ></i-count-up>
              </div>
              <div class="products-stat__type">Total Sales</div>
            </div>
          </div>
        </div>

        <div class="products-info products-info--top">
          <h6 v-if="hasMultipleVendors" class="products__vendor">{{ vendor }}</h6>
          <h2 class="products__title" ref="title">
            <TextOverflowClip :text="title" />
          </h2>
          <p class="products__prices">
            <span class="products__price">{{ price | currency }}</span>
            <span class="products__compare-at-price" v-if="compareAtPrice">{{ compareAtPrice | currency }}</span>
          </p>
        </div>
        <div class="products-info products-info--bottom">
          <span class="products__total-variants">{{ totalVariants }} Variants</span>
        </div>
      </a>

      <template v-if="share">
        <open-modal-control :view="'modal-view-share'" :props="shareData">
          <div class="products-stats-share">
            <button type="button" class="products-stats-share__button icon--send"><span class="hide--visually">Share</span></button>
          </div>
        </open-modal-control>
      </template>

      <div class="product-tile__matte" />

      <div class="products__more-container">
        <additional-links-menu
          :above="true"
          :links="[
            {
              text: 'Share',
              share: shareData
            },
            {
              target: '_parent',
              text: 'Edit in Shopify',
              url: platformAdminUrl
            },
            {
              target: '_blank',
              text: 'View on Live Site',
              url: platformUrl
            }
          ]"
          @update-menu-focus-state="setAdditionalLinksMenuFocusState"
        >
          <button type="button" class="products__more icon--more-menu"><span class="hide--visually">Actions</span></button>
        </additional-links-menu>
      </div>
    </div>
  </li>
</template>

<script>
  import ICountUp from 'vue-countup-v2'
  import { mapState } from 'vuex'

  import AdditionalLinksMenu from '@/components/AdditionalLinksMenu'
  import OpenModalControl from '@/components/OpenModalControl'
  import ProductTileBadge from '@/components/ProductTileBadge'
  import TextOverflowClip from '@/components/TextOverflowClip'

  export default {
    name: 'productTile',
    components: {
      'additional-links-menu': AdditionalLinksMenu,
      'open-modal-control': OpenModalControl,
      ProductTileBadge,
      'i-count-up': ICountUp,
      TextOverflowClip
    },
    props: {
      product: Object,
      compareAtPrice: {
        default: null,
        required: false
      },
      href: {
        default: false,
        type: [Boolean, String]
      },
      hot: {
        default: false,
        type: Boolean
      },
      hover: {
        default: false,
        type: Boolean
      },
      id: {
        default: '',
        type: [String, Number]
      },
      image: {
        default: null,
        required: true
      },
      inventory: {
        default: 0,
        required: true,
        type: Number
      },
      menu: {
        default: false,
        type: Boolean
      },
      platformUrl: {
        default: 'javascript:void(0);',
        type: String
      },
      platformAdminUrl: {
        default: 'javascript:void(0);',
        type: String
      },
      price: {
        default: 0,
        required: true,
        type: Number
      },
      published: {
        default: null,
        type: [ Object, String ]
      },
      scrollmagic: {
        default: false,
        type: Boolean
      },
      share: {
        default: true,
        type: Boolean
      },
      title: {
        default: '',
        required: true,
        type: String
      },
      totalSales: {
        default: 0,
        required: true,
        type: Number
      },
      totalVariants: {
        default: 0,
        required: true,
        type: Number
      },
      unitsSold: {
        default: 0,
        required: true,
        type: Number
      },
      vendor: {
        type: String
      }
    },
    data () {
      return {
        additionalLinksMenuFocused: false,
        countUpMoney: {
          prefix: this.$currency
        }
      }
    },
    computed: {
      ...mapState(
        'shop',
        [
          'hasMultipleVendors'
        ]
      ),
      shareData: function () {
        const {
          image,
          title,
          vendor
        } = this

        const shareData = {
          pageHeadline: title,
          pageSubline: vendor,
          linkUrl: `https://app.helloseemore.com/product/${this.id}`,
          thumbnailUrl: image ? image.url : null,
          productId: this.id
        }

        return shareData
      }
    },
    methods: {
      click () {
        this.productDetail()
      },
      productDetail () {
        this.$emit('loadProductDetail', this.id)
      },
      setAdditionalLinksMenuFocusState (focused) {
        this.additionalLinksMenuFocused = focused
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/js/components/ProductTile.vue